import axios from "./AxiosService";

export function findDocuments(membershipNumber) {
  return axios
    .get("documents", {
      params: { membershipNumber: membershipNumber }
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return error && error.response && error.response.data;
    });
}

export function findRenewalDocuments(membershipNumber) {
  return axios
    .get("documents", {
      params: { membershipNumber: membershipNumber, isRenewal: true }
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return error && error.response && error.response.data;
    });
}

export function retrieveDocument(membershipNumber, documentId) {
  return axios
    .get("documents", {
      params: {
        membershipNumber: membershipNumber,
        documentId: documentId
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json"
      },
      responseType: "blob"
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return;
    });
}
